export const socialLinks = [
  {
    id: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/authorjanecorry/',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/janecorry',
  },
  {
    id: 'x',
    label: 'X (Twitter)',
    url: 'https://twitter.com/JaneCorryAuthor',
  },
];

export const contactSections = [
  {
    id: 'publicity',
    title: 'My Publicity Contacts at Penguin are:',
    people: [
      {name: 'Jane Gentle', email: 'JGentle@penguinrandomhouse.co.uk'},
      {name: 'Rebecca Gray PR', email: 'rebeccagraypr@gmail.com'},
    ],
  },
  {
    id: 'agent',
    title: 'My Literary Agent is:',
    people: [{name: 'Kate Hordern at KHLA', email: 'kate@khla.co.uk'}],
  },
  {
    id: 'film-tv',
    title: 'My film and tv agents are:',
    people: [
      {
        name: 'Jenna Brown at Penguin Random House',
        email: 'JBrown2@penguinrandomhouse.co.uk',
      },
      {
        name: 'Italia Gandolfo, CEO of Gandolfo, Helin and Fountain Literary Management',
        email: 'italia@ghliterary.com',
      },
    ],
  },
];
